import * as React from 'react';
import { ComponentProps } from '../DataTable';

export interface ColumnFilterProps extends ComponentProps {
    /**
     * The function to call when the input changes
     */
    onChange: (filterText: string) => void;
    /**
     * The name of the column we're filtering on
     */
    columnName: string;
    /**
     * The text of the filter input
     * (the state resides in the DataTable component)
     */
    filterText: string;
}

/**
 * This is the column filter component
 * @param props Component Props
 */
export function ColumnFilter(props: ColumnFilterProps) {
    const id = props.columnName + 'Filter_' + props.idSuffix;
    return (
        <div className="form-group">
            <label className="form-label" htmlFor={id}>
                {props.columnName}
            </label>
            <input
                type="text"
                id={id}
                value={props.filterText}
                onChange={event => props.onChange(event.target.value)}
            />
        </div>
    );
}
